import * as moment from "moment";
import React, { useEffect, useState } from "react";
import { NumericFormat } from "react-number-format";
import { toast } from "react-toastify";
import {
  Modal,
  ModalBody,
} from "reactstrap";
import {
  Block,
  BlockBetween,
  BlockHead,
  BlockHeadContent,
  BlockTitle,
  Button,
  Col,
  Icon,
} from "../../components/Component";
import DatePicker from "../../components/range-date-picker/RangeDatePicker";
import Table from "../../components/react-table/Table";
import { GET, POST } from "../../helper/api";
import Content from "../../layout/content/Content";
import Head from "../../layout/head/Head";

import { useLocation } from "react-router-dom";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";
import { useUser } from "../../context/user";

const MyPieceWageManager = () => {
  const {
    state: {
      user,
    },
  } = useUser();

  const history = useHistory();
  const [data, setData] = useState([]);
  const [view, setView] = useState({
    isConfirm: false
  });


  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const [loading, setLoading] = useState(false);
  const [confirmId, setConfirmId] = useState();
  const [timeNow, setTimeNow] = useState();
  const [smOption, setSmOption] = useState(false);

  const [rangeDate, setRangeDate] = useState({
    startDate: searchParams.get("startDate")
      ? moment(searchParams.get("startDate")).startOf("months").toDate()
      : moment().startOf("days").toDate(),
    endDate: searchParams.get("endDate")
      ? moment(searchParams.get("endDate")).endOf("days").toDate()
      : moment().endOf("days").toDate(),
  });

  const onRangeChange = (dates) => {
    const [startDate, endDate] = dates;
    setRangeDate({
      startDate: startDate
        ? moment(startDate)?.startOf("days").toDate()
        : startDate,
      endDate: endDate ? moment(endDate)?.endOf("days").toDate() : endDate,
    });
    if (startDate && endDate) {
      setTimeNow(moment().valueOf());
    }
  };

  const colTable = [
    {
      Header: "Ngày",
      accessor: (item) => moment(item.date).format("DD/MM/YYYY"),
    },
    {
      Header: "Xuống hàng(đ)",
      className: 'text-right',
      accessor: (item) => (
        <NumericFormat
          displayType={"text"}
          value={item.salaryPerEmployee || 0}
          thousandsGroupStyle="thousand"
          thousandSeparator=","
          decimalScale={2}
        />
      ),
    },
    {
      Header: "Xác nhận",
      accessor: (item) =>
        item.userAgreedIds?.includes(user?.id) ? (
          "Đã xác nhận"
        ) : (
          <Col>
            <Button
              className={"btn btn-primary"}
              onClick={() => {
                setConfirmId(item.id);
                toggle('isConfirm')
              }}
            >
              Xác nhận
            </Button>
          </Col>
        ),
    },
  ];


  // Changing state value when searching name
  useEffect(() => {
    const newParams = new URLSearchParams({
      ...rangeDate,
    });
    history.replace({
      pathname: location.pathname,
      search: newParams.toString(),
    });

    setLoading(true);
    setData([]);
    let params = {
      startDate: moment(rangeDate.startDate).format("YYYY-MM-DD"),
      endDate: moment(rangeDate.endDate).format("YYYY-MM-DD"),
    };

    GET(`self-employee/piece-wage`, params, true)
      .then(({ data }) => {
        setData([...data]);
      })
      .finally(() => {
        setLoading(false);
      });
  }, [timeNow]);

  // toggle function to view order details
  const toggle = (type) => {
    setView({
      ...view,
      [type]: !view[type],
    });
  };

  const resetData = () => {
    onFormCancel();
    setTimeNow(moment().valueOf());
  };

  // function to close the form modal
  const onFormCancel = () => {
    setView({ isConfirm: false });
    setConfirmId("");
  };

  const confirmPieceWage = (id) => {
    if (!id) {
      return;
    }

    POST(`self-employee/agree-piece-wage/${id}`, {}, {}, true)
      .then((res) => {
        toast.success("Xác nhận thành công");
        resetData();
      })
      .catch(({ response }) => {
        toast.error(
          response?.data?.error || "Có lỗi xảy ra! Vui lòng thử lại."
        );
      });
  };

  return (
    <React.Fragment>
      <Head title="Xuống hàng của tôi"></Head>
      <Content>
        <BlockHead size="sm">
          <BlockBetween>
            <BlockHeadContent>
              <BlockTitle page>Xuống hàng của tôi</BlockTitle>
            </BlockHeadContent>
            <BlockHeadContent>
              <div className="toggle-wrap nk-block-tools-toggle">
                <a
                  href="#more"
                  className="btn btn-icon btn-trigger toggle-expand mr-n1"
                  onClick={(ev) => {
                    ev.preventDefault();
                    setSmOption(!smOption);
                  }}
                >
                  <Icon name="more-v"></Icon>
                </a>
                <div
                  className="toggle-expand-content"
                  style={{ display: smOption ? "block" : "none" }}
                >
                  <ul className="d-lg-flex g-3 pt-1 pb-1 custom-filter-header justify-content-end">
                    <li>
                      <div className="form-control-wrap">
                        <DatePicker
                          selected={rangeDate.startDate}
                          startDate={rangeDate.startDate}
                          onChange={onRangeChange}
                          endDate={rangeDate.endDate}
                          maxDate={new Date()}
                          selectsRange
                          className="form-control date-picker"
                        />
                      </div>
                    </li>
                  </ul>
                </div>
              </div>
            </BlockHeadContent>
          </BlockBetween>
        </BlockHead>

        <Block>
          <div className="card card-bordered card-preview">
            <div className="card-inner">
              <div
                id="DataTables_Table_1_wrapper"
                className="dataTables_wrapper dt-bootstrap4 no-footer"
              >
                <div className="row justify-between g-2">
                  <div className="col-8 col-sm-6 text-start"></div>
                  <div className="col-5 col-sm-6 text-end">
                    <div className="datatable-filter">
                      <div className="d-flex justify-content-end g-2">
                        <div
                          className="dataTables_length"
                          id="DataTables_Table_1_length"
                        ></div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="my-3">
                  <Table
                    loading={loading}
                    columns={colTable}
                    data={data}
                    notShowPagi={true}
                  ></Table>
                </div>
              </div>
            </div>
          </div>
        </Block>


        <Modal isOpen={view.isConfirm} toggle={() => onFormCancel()}>
          <ModalBody className="modal-body-lg text-center">
            <div className="nk-modal">
              <Icon className="nk-modal-icon icon-circle icon-circle-xxl ni ni-check bg-success"></Icon>
              <h4 className="nk-modal-title">
                Bạn có chắc xác nhận xuống hàng này không ?{" "}
              </h4>
              <div className="nk-modal-action mt-5 d-flex justify-content-around">
                <Button
                  color="light"
                  size="lg"
                  className="btn-mw mr-5"
                  onClick={() => onFormCancel()}
                >
                  Huỷ bỏ
                </Button>
                <Button
                  color="primary"
                  size="lg"
                  className="btn-mw"
                  onClick={(ev) => {
                    ev.preventDefault();
                    confirmPieceWage(confirmId);
                  }}
                >
                  Xác nhận
                </Button>
              </div>
            </div>
          </ModalBody>
        </Modal>


      </Content>
    </React.Fragment>
  );
};

export default MyPieceWageManager;
